var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      style: _vm.svgStyle,
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 501.643 395.923",
        "xml:space": "preserve"
      }
    },
    [
      _c("g", { attrs: { id: "Background" } }),
      _vm._v(" "),
      _c("g", { attrs: { id: "Objects" } }, [
        _c("g", [
          _c("path", {
            staticClass: "st0",
            attrs: {
              d:
                "M466.43,104.92h-13.739v151.017c0,23.529-13.674,44.791-41.136,44.791H142.662v7.18\n        c0,20.805,23.644,41.772,47.924,41.772h205.598l78.649,46.243l-11.422-46.243h3.019c24.264,0,35.213-20.951,35.213-41.772V140.769\n        C501.643,119.981,490.694,104.92,466.43,104.92z"
            }
          }),
          _vm._v(" "),
          _c("path", {
            staticClass: "st0",
            attrs: {
              d:
                "M371.415,0H59.101C31.623,0,0,24.411,0,47.94v189.281c0,21.669,26.793,37.318,52.493,39.716l-16.725,63.491\n        l107.172-63.034h228.475c27.462,0,52.835-16.66,52.835-40.173V84.083V47.94C424.25,24.411,398.877,0,371.415,0z M106.748,159.779\n        c-15.583,0-28.213-12.63-28.213-28.213c0-15.583,12.63-28.213,28.213-28.213c15.567,0,28.213,12.63,28.213,28.213\n        C134.961,147.15,122.315,159.779,106.748,159.779z M212.125,159.779c-15.583,0-28.213-12.63-28.213-28.213\n        c0-15.583,12.63-28.213,28.213-28.213s28.213,12.63,28.213,28.213C240.338,147.15,227.708,159.779,212.125,159.779z\n         M317.518,159.779c-15.583,0-28.229-12.63-28.229-28.213c0-15.583,12.646-28.213,28.229-28.213\n        c15.55,0,28.213,12.63,28.213,28.213C345.731,147.15,333.069,159.779,317.518,159.779z"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }